<template>
  <div class="d-inline">
    <b-link
      class="btn btn-sm btn-primary text-light mr-2"
      @click="$bvModal.show(`modal-uploadHelperImage-${imgType.imgType}`)"
      ><font-awesome-icon icon="image" class="mr-2" />{{
        imgType.label
      }}</b-link
    >
    <b-modal
      :id="`modal-uploadHelperImage-${imgType.imgType}`"
      :title="`Upload ${imgType.label} image`"
      size="lg"
      body-bg-variant="light"
      header-bg-variant="secondary"
      header-text-variant="dark"
      ok-disabled
      centered
    >
      {{ imgType }}
      <b-row class="mt-5 justify-content-center">
        <b-col md="10">
          <b-form class="login">
            <b-form-row>
              <b-col cols="12">
                <b-form-group
                  description="Single image in .jpg or .png format."
                >
                  <b-form-file
                    v-model="form.file"
                    :state="Boolean(form.file)"
                    placeholder="Choose a file or drop it like it's hot here ..."
                    drop-placeholder="Drop it like it's hot here..."
                  ></b-form-file>
                  <div class="mt-3">
                    Selected file: {{ form.file ? form.file.name : "" }}
                  </div>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button
          @click="$bvModal.hide(`modal-uploadHelperImage-${imgType.imgType}`)"
          class="btn btn-muted btn-md"
        >
          Cancel
        </b-button>
        <b-button
          type="submit"
          @click="onSubmit"
          class="btn btn-dark btn-md"
          :disabled="isSending"
        >
          Upload {{ imgType.label }} Image
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  props: ["imgType"],
  data() {
    return {
      isSending: false,
      uploadProgress: "",
      form: {
        file: null,
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;

      const config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(percentCompleted);
        },
      };

      let formData = new FormData();
      formData.append("file", this.form.file);

      let helper_type =
        this.imgType.type === "project" ? "projects" : "packages";

      return new Promise((resolve, reject) => {
        axios(
          {
            url: `${this.$store.state.login.url}/api/dashboard/${helper_type}/${this.imgType.id}/help_image/upload`,
            data: formData,
            headers: {
              Authorization: `Bearer ${this.$store.state.login.token}`,
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
            },
            params: { img_type: this.imgType.imgType },
            method: "POST",
          },
          config
        )
          .then((response) => {
            this.isSending = false;
            this.$bvModal.hide("modal-uploadImages");
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
            // TODO: REMOVE THIS FOR PRODUCTION
            setTimeout(() => {
              this.$router.go();
            }, 1000);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
  },
};
</script>
